import PropTypes from 'prop-types'
import { getAccessibleTextColor, darken, styled } from '../../utilities';

const StyledButton = styled.button.attrs(props => {
  return {
    className: props.className
  }
})`
  ${({ $solid, $outline, $variant = 'primary', theme = {} }) => {
      const { type } = theme
      const color = theme[$variant] 
      const accessibleColor = color ? getAccessibleTextColor(color) : ''
      if($outline) {
          let styling = {};
          if (type === "dark") {
            styling.border = `2px solid white`;
            styling.color = `white`;
          } else {
            (styling.border = `2px solid ${color}`), (styling.color = color);
          }
          styling.backgroundColor = "transparent";
          return {
            ...styling,
            [`&:hover`]: {
              backgroundColor: color,
              color: accessibleColor,
            },
            ['&:focus']: {
              borderStyle: 'dashed'
            }
          };
      } else if ($solid) {
        return {
            backgroundColor: color,
            color: accessibleColor,
            [`&:hover, &:focus`]: {
                backgroundColor: color ? darken(color, .2) : ''
            }
        }
    }
  }}
`;

StyledButton.propTypes = {
    $solid: PropTypes.bool,
    $outline: PropTypes.bool,
    $variant: PropTypes.string,
}

export default StyledButton